import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import ServiceCard from '../components/service-card'
import BenefitCard from '../components/benefit-card'
import FAQs from '../components/fa-qs'
import Footer from '../components/footer'
import './home-en.css'

const HomeEn = (props) => {
  return (
    <div className="home-en-container10">
      <Helmet>
        <title>Copy of iCharge web copy 2</title>
        <meta property="og:title" content="Copy of iCharge web copy 2" />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="home-en-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="home-en-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="home-en-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="home-en-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="home-en-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="home-en-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="home-en-text16">Cultivating Connection</span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="home-en-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="home-en-text21">How to charge</span>
          </Fragment>
        }
        rootClassName="navbarroot-class-name13"
        chargingPointLink1={
          <Fragment>
            <span className="home-en-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="home-en-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <main className="column align-center full-width">
        <section className="home-en-hero column align-center justify-center full-width thq-section-padding">
          <div className="home-en-max-width10 row full-width max-content-width">
            <div className="home-en-right column gap-2-5">
              <h1 className="home-en-text24 heading-1">Powering the Future</h1>
              <p className="home-en-text25 sub-heading-2">
                The most advanced platform for electric vehicle charging in
                Albania
              </p>
              <div className="home-en-container11">
                <a
                  href="https://apps.apple.com/us/app/icharge-app/id6479523452"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-en-link1"
                >
                  <img
                    alt="pastedImage"
                    src="/Pages/Home/pastedimage-s64t-200h.webp"
                    className="home-en-pasted-image10"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.icharge.mobile.app&amp;hl=en"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-en-link2"
                >
                  <img
                    alt="pastedImage"
                    src="/Pages/Home/googleplay-200h.webp"
                    className="home-en-pasted-image11"
                  />
                </a>
              </div>
            </div>
            <div className="home-en-container12">
              <img
                alt="pastedImage"
                src="/iphone%20mockup.svg"
                className="home-en-pasted-image12"
              />
            </div>
          </div>
        </section>
        <section className="home-en-mission column align-center justify-center full-width thq-section-padding">
          <div className="home-en-max-width11 row full-width max-content-width">
            <div className="home-en-content1 column gap-5">
              <div className="column gap-5">
                <h3 className="home-en-text26 heading-2">
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Our Mission</span>
                </h3>
                <p className="home-en-text29 sub-heading-2">
                  <span>
                    iCharge.app is the largest network of electric vehicle
                    charging stations in Albania.
                  </span>
                  <br></br>
                  <span>
                    We provide a smart, easy-to-use, and affordable solution for
                    every driver.
                  </span>
                  <br></br>
                  <span>
                    Through our app, users can effortlessly locate the nearest
                    charging point and enjoy a safe, reliable, and efficient
                    service.
                  </span>
                </p>
              </div>
              <a
                href="https://m.icharge.app/#/homepage"
                target="_blank"
                rel="noreferrer noopener"
                className="home-en-link3 button-large button-primary thq-button-animated"
              >
                Locate a Charger
              </a>
            </div>
            <div className="home-en-container14">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/pastedimage-5qvx-1500h.webp"
                srcSet="/Pages/Home//pastedimage-5qvx-1500h.webp 1200w, /Pages/Home/pastedimage-5qvx-tablet.webp 800w, /Pages/Home/pastedimage-5qvx-mobile.webp 480w"
                className="home-en-pasted-image13"
              />
            </div>
          </div>
        </section>
        <section className="home-en-services column align-center justify-center full-width thq-section-padding">
          <div className="home-en-max-width12 column align-center full-width max-content-width">
            <div className="home-en-header1 column align-center gap-2-5">
              <div className="row">
                <h2 className="home-en-text35 heading-2">Our Services</h2>
              </div>
            </div>
            <div className="home-en-cards-container1 full-width">
              <ServiceCard
                text={
                  <Fragment>
                    <span className="home-en-text36">
                      <span>
                        Charging with iCharge is simple, smart, and tailored to
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>your everyday life.</span>
                    </span>
                  </Fragment>
                }
                heading={
                  <Fragment>
                    <span className="home-en-text40">
                      <span>
                        Charging
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>Service</span>
                    </span>
                  </Fragment>
                }
                imageSrc="/Pages/Home/pastedimage-1ecb-1500h.webp"
                rootClassName="service-cardroot-class-name47"
              ></ServiceCard>
              <ServiceCard
                text={
                  <Fragment>
                    <span className="home-en-text44">
                      <span>
                        The EV journey
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>goes beyond borders.</span>
                    </span>
                  </Fragment>
                }
                heading={
                  <Fragment>
                    <span className="home-en-text48">
                      <span>Roaming</span>
                      <br></br>
                      <span> (International Charging)</span>
                    </span>
                  </Fragment>
                }
                imageSrc="/Pages/Home/pastedimage-6gm5-1500h.webp"
                rootClassName="service-cardroot-class-name48"
              ></ServiceCard>
              <ServiceCard
                text={
                  <Fragment>
                    <span className="home-en-text52">
                      <span>
                        Technology works best
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>
                        when paired with
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>reliable support.</span>
                    </span>
                  </Fragment>
                }
                heading={
                  <Fragment>
                    <span className="home-en-text58">
                      <span>
                        24/7
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>Technical Support</span>
                    </span>
                  </Fragment>
                }
                imageSrc="/Pages/Home/pastedimage-xncv-1500h.webp"
                rootClassName="service-cardroot-class-name49"
              ></ServiceCard>
            </div>
          </div>
        </section>
        <section
          id="steps"
          className="home-en-steps column align-center justify-center full-width thq-section-padding"
        >
          <div className="home-en-max-width13 column align-center full-width max-content-width">
            <div className="home-en-header2 column align-center gap-2-5">
              <div className="home-en-container16 column">
                <h2 className="home-en-text62 heading-2">
                  Charge in 3 Simple Steps
                </h2>
                <span className="home-en-text63 sub-heading-1">
                  Start your journey without waiting
                </span>
                <ul className="home-en-ul1 list">
                  <li className="home-en-li1 list-item">
                    <span className="home-en-text64 sub-heading-2">
                      Connect the charging gun to your vehicle.
                    </span>
                  </li>
                  <li className="home-en-li2 list-item">
                    <span className="home-en-text65 sub-heading-2">
                      Scan the QR code on the charger.
                    </span>
                  </li>
                  <li className="home-en-li3 list-item">
                    <span className="home-en-text66 sub-heading-2">
                      Start charging via the app and you’re ready to go.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="home-en-cards-container2 full-width">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/pastedimage-p1wg-1200w.webp"
                srcSet="/Pages/Home//pastedimage-p1wg-1200w.webp 1200w, /Pages/Home/pastedimage-p1wg-tablet.webp 800w, /Pages/Home/pastedimage-p1wg-mobile.webp 480w"
                className="home-en-pasted-image14"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/pastedimage-f8me-1200w.webp"
                srcSet="/Pages/Home//pastedimage-f8me-1200w.webp 1200w, /Pages/Home/pastedimage-f8me-tablet.webp 800w, /Pages/Home/pastedimage-f8me-mobile.webp 480w"
                className="home-en-pasted-image15"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/pastedimage-ad7-1200w.webp"
                srcSet="/Pages/Home//pastedimage-ad7-1200w.webp 1200w, /Pages/Home/pastedimage-ad7-tablet.webp 800w, /Pages/Home/pastedimage-ad7-mobile.webp 480w"
                className="home-en-pasted-image16"
              />
            </div>
          </div>
        </section>
        <section className="home-en-who-benefits column align-center justify-center full-width thq-section-padding">
          <div className="home-en-max-width14 column align-center full-width max-content-width">
            <div className="home-en-header3 column align-center gap-2-5">
              <div className="home-en-container17 column">
                <h2 className="home-en-text67 heading-2">Who Benefits</h2>
              </div>
            </div>
            <div className="home-en-cards-container3 full-width">
              <BenefitCard
                text={
                  <Fragment>
                    <span className="home-en-text68">
                      Charge quickly and easily with iCharge at over 50 stations
                      across Albania.
                    </span>
                  </Fragment>
                }
                title={
                  <Fragment>
                    <span className="home-en-text69">
                      Electric Vehicle Drivers
                    </span>
                  </Fragment>
                }
                thumbnailSrc="/Pages/Home/p1280785%20copy-1500w.webp"
                rootClassName="benefit-cardroot-class-name5"
              ></BenefitCard>
              <BenefitCard
                text={
                  <Fragment>
                    <span className="home-en-text70">
                      <span>
                        Attract more visitors by providing electric vehicle
                        charging.
                      </span>
                      <br></br>
                    </span>
                  </Fragment>
                }
                title={
                  <Fragment>
                    <span className="home-en-text73">
                      <span>Hotels and Businesses</span>
                      <br></br>
                    </span>
                  </Fragment>
                }
                thumbnailSrc="/Pages/Home/teg%20web-1500w.webp"
                rootClassName="benefit-cardroot-class-name6"
              ></BenefitCard>
              <BenefitCard
                text={
                  <Fragment>
                    <span className="home-en-text76">
                      Offer charging services, increase business value, and
                      contribute to a greener future.
                    </span>
                  </Fragment>
                }
                title={
                  <Fragment>
                    <span className="home-en-text77">Transport Companies</span>
                  </Fragment>
                }
                thumbnailSrc="/Pages/Home/taxi-1500w.webp"
                rootClassName="benefit-cardroot-class-name7"
              ></BenefitCard>
              <BenefitCard
                text={
                  <Fragment>
                    <span className="home-en-text78">
                      Promote sustainable transport for staff and visitors.
                    </span>
                  </Fragment>
                }
                title={
                  <Fragment>
                    <span className="home-en-text79">
                      Public Organizations and Institutions
                    </span>
                  </Fragment>
                }
                thumbnailSrc="/Pages/Home/m%20busqesis-1500w.webp"
                rootClassName="benefit-cardroot-class-name8"
              ></BenefitCard>
            </div>
          </div>
        </section>
        <section className="home-en-platform1 column align-center justify-center full-width thq-section-padding">
          <div className="home-en-max-width15 column align-center full-width max-content-width">
            <div className="home-en-cards-container4 full-width">
              <div className="home-en-container18 column">
                <h2 className="home-en-text80 heading-2">iCharge Platform</h2>
                <span className="home-en-text81 sub-heading-1">
                  A dedicated dashboard for managing charging stations in
                  real-time.
                </span>
                <div className="home-en-max-width16 row full-width gap-8 max-content-width">
                  <div className="home-en-content2 column gap-5">
                    <div className="column gap-5">
                      <ul className="home-en-ul2 list">
                        <li className="home-en-li4 list-item">
                          <span className="home-en-text82 sub-heading-2">
                            <span className="home-en-text83">
                              Monitor Stations
                            </span>
                            <span>
                              : Monitor Stations: Check online/offline status,
                              connectivity issues, and key usage stats.
                            </span>
                          </span>
                        </li>
                        <li className="home-en-li5 list-item">
                          <span className="home-en-text85 sub-heading-2">
                            <span className="home-en-text86">Full Control</span>
                            <span>
                              : Start charging sessions, set prices, and manage
                              users—all from a single dashboard.
                            </span>
                          </span>
                        </li>
                        <li className="home-en-li6 list-item">
                          <span className="home-en-text88">
                            <span className="home-en-text89">
                              Reporting &amp; Analytics
                            </span>
                            <span>
                              : Generate detailed reports for each station,
                              user, or time period.
                            </span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="home-en-container20">
                    <img
                      alt="pastedImage"
                      sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                      src="/Pages/Home/mockup%204-1500w.webp"
                      srcSet="/Pages/Home//mockup%204-1500w.webp 1200w, /Pages/Home/mockup%204-tablet.webp 800w, /Pages/Home/mockup%204-mobile.webp 480w"
                      className="home-en-pasted-image17"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="home-en-integrating column align-center justify-center full-width thq-section-padding gap-8">
          <h2 className="home-en-text91 heading-2">
            Integrating the Platform into Your Business
          </h2>
          <div className="home-en-max-width17 row full-width gap-8 max-content-width">
            <div className="home-en-content3 column gap-5">
              <div className="column gap-5">
                <p className="home-en-text92 sub-heading-2">
                  iCharge for businesses provides a complete, reliable solution
                  for installing and managing electric vehicle charging
                  stations. Our platform is flexible, easy to use, and adaptable
                  to the needs of any business—from hotels to commercial fleets.
                </p>
              </div>
              <Link
                to="/icharge-platform"
                className="home-en-navlink1 button-large button-primary thq-button-animated"
              >
                More
              </Link>
            </div>
            <div className="home-en-container22">
              <img
                alt="pastedImage"
                src="/Pages/Home/mockup%203.svg"
                className="home-en-pasted-image18"
              />
            </div>
          </div>
        </section>
        <section
          id="faq"
          className="home-en-faq column align-center justify-center full-width thq-section-padding"
        >
          <div className="home-en-max-width18 column align-center full-width max-content-width">
            <div className="home-en-cards-container5 full-width">
              <div className="home-en-container23 column">
                <h2 className="home-en-text93 heading-2">
                  Frequently Asked Questions
                </h2>
                <span className="home-en-text94 sub-heading-1">
                  These are the questions our visitors ask most often
                </span>
              </div>
              <FAQs
                faq3Answer={
                  <Fragment>
                    <span className="home-en-text95">
                      With iCharge Roaming, you can now see where you can charge
                      your vehicle across Europe. Always check the app for
                      available stations in your area before traveling dy here.
                    </span>
                  </Fragment>
                }
                faq1Question={
                  <Fragment>
                    <span className="home-en-text96">
                      How to Charge Your Vehicle Using iCharge
                    </span>
                  </Fragment>
                }
                faq2Question={
                  <Fragment>
                    <span className="home-en-text97">
                      How to Top Up Your Balance
                    </span>
                  </Fragment>
                }
                faq3Question={
                  <Fragment>
                    <span className="home-en-text98">
                      Is iCharge Available Internationally?
                    </span>
                  </Fragment>
                }
                faq1ListItems={5}
                rootClassName="fa-qsroot-class-name1"
              ></FAQs>
            </div>
          </div>
        </section>
        <section className="home-en-trusted-by column align-center justify-center full-width thq-section-padding">
          <div className="home-en-max-width19 column align-center full-width max-content-width">
            <div className="home-en-header4 column align-center gap-2-5">
              <div className="home-en-container24 column">
                <h2 className="home-en-text99 heading-2">Trusted by</h2>
              </div>
            </div>
            <div className="home-en-cards-container6 full-width">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/balfin_logo.svg-1500w.webp"
                srcSet="/Logos/Partners//balfin_logo.svg-1500w.webp 1200w, /Logos/Partners/balfin_logo.svg-tablet.webp 800w, /Logos/Partners/balfin_logo.svg-mobile.webp 480w"
                className="home-en-pasted-image19"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/logo-kurum-1500w.webp"
                srcSet="/Logos/Partners//logo-kurum-1500w.webp 1200w, /Logos/Partners/logo-kurum-tablet.webp 800w, /Logos/Partners/logo-kurum-mobile.webp 480w"
                className="home-en-pasted-image20"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/logo%20green%20taxi-1500w.webp"
                srcSet="/Logos/Partners//logo%20green%20taxi-1500w.webp 1200w, /Logos/Partners/logo%20green%20taxi-tablet.webp 800w, /Logos/Partners/logo%20green%20taxi-mobile.webp 480w"
                className="home-en-pasted-image21"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/logo%20king%20taxi-1500w.webp"
                srcSet="/Logos/Partners//logo%20king%20taxi-1500w.webp 1200w, /Logos/Partners/logo%20king%20taxi-tablet.webp 800w, /Logos/Partners/logo%20king%20taxi-mobile.webp 480w"
                className="home-en-pasted-image22"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/aiba%20logo-1500w.webp"
                srcSet="/Logos/Partners//aiba%20logo-1500w.webp 1200w, /Logos/Partners/aiba%20logo-tablet.webp 800w, /Logos/Partners/aiba%20logo-mobile.webp 480w"
                className="home-en-pasted-image23"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/logo-grand-taxi-1500w.webp"
                srcSet="/Logos/Partners//logo-grand-taxi-1500w.webp 1200w, /Logos/Partners/logo-grand-taxi-tablet.webp 800w, /Logos/Partners/logo-grand-taxi-mobile.webp 480w"
                className="home-en-pasted-image24"
              />
            </div>
          </div>
        </section>
        <section
          id="contact"
          className="home-en-platform2 column align-center justify-center full-width thq-section-padding"
        >
          <div className="home-en-max-width20 column align-center full-width max-content-width">
            <div className="home-en-cards-container7 full-width">
              <div className="home-en-container25 column gap-3-5">
                <h2 className="home-en-text100 heading-3">
                  <span className="home-en-text101">
                    Funding for Charging Stations
                  </span>
                  <br></br>
                </h2>
                <span className="home-en-text103 sub-heading-1">
                  iCharge.app welcomes collaborations with businesses looking to
                  expand the charging station network. Contact us to explore
                  partnership opportunities.
                </span>
                <Link
                  to="/help-center"
                  className="home-en-navlink2 button-large button-primary thq-button-animated"
                >
                  Contact
                </Link>
              </div>
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/external/pastedimage-56qs-1500w.webp"
                srcSet="/external//pastedimage-56qs-1500w.webp 1200w, /external/pastedimage-56qs-tablet.webp 800w, /external/pastedimage-56qs-mobile.webp 480w"
                className="home-en-pasted-image25"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer rootClassName="footerroot-class-name12"></Footer>
    </div>
  )
}

export default HomeEn
